import { render, staticRenderFns } from "./OrgCard.vue?vue&type=template&id=66537286&scoped=true&"
import script from "./OrgCard.vue?vue&type=script&lang=js&"
export * from "./OrgCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66537286",
  null
  
)

export default component.exports